import { createContext } from 'react';

const bypassContext = createContext({
    contentId: 'main-content',
    setContentId() {}
});

export default bypassContext;
